/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type userTracking_user = {|
  +firstSessionDate: ?string;
  +isTrade: ?boolean;
  +hasVipPermission: ?boolean;
  +profile: ?{|
    +email: ?string;
    +zipCode: ?string;
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  |};
  +serviceId: ?string;
  +totalMessagesToDealers: ?number;
  +tradeFirm: ?{|
    +serviceId: ?string;
    +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
  |};
  +verifiedTradeStatus: ?string;
  +activePromotion: ?{|
    +serviceId: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "firstSessionDate",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "isTrade",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_TRADE_CHECKOUT",
          "type": "String!"
        }
      ],
      "name": "hasPermission",
      "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "hasVipPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_VIP_CHECKOUT",
          "type": "String!"
        }
      ],
      "name": "hasPermission",
      "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "zipCode",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalMessagesToDealers",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "name": "tradeFirm",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "verifiedTradeStatus",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Promotion",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
